<template>
  <button class="vv-button" @click="onClick" :disabled="disabled" v-bind:class="customClass">
    <slot>Button</slot>
  </button>
</template>

<script>
export default {
  name: 'VvButton',
  props: {
    disabled: Boolean,
    customClass: String
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/_variables.scss';

.vv-button {
  padding: 10px 38px;
  border: 0;
  border-radius: 20px;
  color: $font-button;
  font-size: 14px;
  font-weight: 900;
  background-color: $tertiary;
  // box-shadow: 0 14px 28px 5px rgba(220, 220, 220, 0.5);
  cursor: pointer;

  &:focus {
    outline: 0;
  }

  &:active {
    background-image: linear-gradient(85deg, $tertiary, $primary);
  }

  &:disabled {
    opacity: 0.41;
  }
}

.white-variant {
  display: flex;
  background-color: white;
  background-image: none;
  border: 1px solid $primary;
  color: $primary;
  vertical-align: center;
  box-shadow: none;

  &:active {
    background-image: none;
  }
}

.primary-variant {
  display: flex;
  background-image: none;
  background-color: $primary;
  vertical-align: center;
  box-shadow: none;

  &:active {
    background-image: none;
  }
}

.full-width {
  width: 100%;
}

.user-form-width {
  width: 76%;
}

.no-shadow {
  box-shadow: none;
}

</style>
